import Card from 'react-bootstrap/Card'
import Table from 'react-bootstrap/Table'
import Badge from 'react-bootstrap/Badge'

const CalendarCell = ({ content, isCurrent }) => {
  const isEmpty = content === '-'
  return (
    <td
      style={{
        minWidth: '128px',
        verticalAlign: 'top',
        backgroundColor: isCurrent ? '#ffe08a' : isEmpty ? '#f8f9fa' : '#ffffff',
        border: isCurrent ? '2px solid #a36d00' : undefined,
        boxShadow: isCurrent ? 'inset 0 0 0 1px rgba(163, 109, 0, 0.25)' : 'none',
        fontWeight: isCurrent ? 700 : 400,
      }}
    >
      {isCurrent ? <div className="mb-1"><Badge bg="dark">NYT</Badge></div> : null}
      <div style={{ whiteSpace: 'pre-line', lineHeight: 1.2 }}>{isEmpty ? '–' : content}</div>
    </td>
  )
}

const TeamSpiritCalendar = ({
  season,
  nationalCompetition,
  worldCompetition,
  currentCalendarPosition,
  dayLabels,
  shouldShowCalendarReset,
}) => {
  const currentWeekRow = currentCalendarPosition.part === season.season
    ? currentCalendarPosition.week
    : null
  const filterCell = (cell, week) => {
    if (cell.includes('JH:n/IL:n palautus')) {
      const isKnownResetWeek =
        (season.season === 1 && [11, 13].includes(week)) ||
        (season.season === 2 && [6, 10, 12].includes(week))
      if (isKnownResetWeek && !shouldShowCalendarReset({ season: season.season, week, nationalCompetition, worldCompetition })) return '-'
    }
    return cell
  }

  return (
    <Card className="mb-4" style={{ backgroundColor: '#f7f8fa', borderColor: '#d7dbe0' }}>
      <Card.Body>
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
          <h3 className="mb-0">{season.title}</h3>
          <Badge bg="warning" text="dark">Nykyinen hetki: kausi {currentCalendarPosition.nationalSeason}, osa {currentCalendarPosition.part}, vko {currentCalendarPosition.week}, {dayLabels[currentCalendarPosition.day - 1].toLowerCase()}</Badge>
        </div>
        <div className="table-responsive"><Table bordered size="sm" className="align-middle mb-0">
          <thead><tr><th style={{ backgroundColor: '#e9eef3', minWidth: '58px' }}>Vko</th>{dayLabels.map(day => <th key={day} style={{ backgroundColor: '#e9eef3', minWidth: '128px' }}>{day}</th>)}</tr></thead>
          <tbody>{season.weeks.map(week => {
            const isCurrentWeek = currentWeekRow === week.week
            return <tr key={week.week} style={{ backgroundColor: isCurrentWeek ? '#fff7d6' : undefined, boxShadow: isCurrentWeek ? 'inset 0 0 0 2px #a36d00' : undefined }}>
              <td style={{ fontWeight: 700, backgroundColor: isCurrentWeek ? '#fff2b3' : '#f8f9fa' }}>{week.week}</td>
              {week.cells.map((cell, dayIndex) => <CalendarCell key={`${season.season}-${week.week}-${dayIndex}`} content={filterCell(cell, week.week)} isCurrent={isCurrentWeek && dayIndex === currentCalendarPosition.day - 1} />)}
            </tr>
          })}</tbody>
        </Table></div>
      </Card.Body>
    </Card>
  )
}

export default TeamSpiritCalendar
